// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VmTr","newExpiryDate":"styles_newExpiryDate__Bdenl","footer":"styles_footer__3jeFO"};